export default __webpack_public_path__ + "static/media/five_of_pentacles.e0b2c5a6.png";